module.exports = __webpack_public_path__ + "img/2a28f91.svg";